// Generated by CoffeeScript 2.7.0
var Response;

import BaseModel from './base_model.js';

export default Response = (function() {
  class Response extends BaseModel {
    constructor(attrs = {}) {
      super(attrs);
    }

  };

  Response.setAttributes([
    'created_at',
    'user',
    {
      entries: [],
      organizations: []
    }
  ]);

  return Response;

}).call(this);
